export default __webpack_public_path__ + "static/insightWhitepaper-0a030c227d7780545122ca6576207bac.svg";